"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingList = void 0;
const filter_header_1 = require("client/components/filter-header");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const store_1 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const store_2 = require("../../store");
require("./reporting-list.less");
const columns = [
    {
        label: "Reports",
        id: "report.reportName"
    }
];
let ReportingList = class ReportingList extends react_1.Component {
    constructor() {
        super(...arguments);
        //  search header
        this.filterText = "";
        this.autoFocusForm = true;
        this.order = "ASC";
        this.orderBy = "report.reportName";
        this.sortedBy = {
            label: "",
            value: ""
        };
        this.onCallback = (value) => {
            this.autoFocusForm = false;
            this.filterText = value.toLowerCase();
            // this.loadReports();
        };
        this.renderListRow = (row, index) => {
            var _a;
            return [
                React.createElement(list_item_1.MaterialListItem, { className: "reporting-row", key: index },
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement("div", { className: "reporting-row--table-row" },
                            React.createElement(material_ui_1.Typography, null, row.reportName),
                            React.createElement(button_1.MaterialButton, { onClick: this.handleReroute(row.route) }, (_a = row.button) !== null && _a !== void 0 ? _a : "Run Report")) }))
            ];
        };
        this.handleReroute = (route) => () => {
            store_2.reportsStore.editModal = true;
            router_1.RouteManager.transitionTo(route);
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
        };
    }
    renderList() {
        const reports = [];
        if (store_1.usersStore.permissions.ReadClaimAnalytics) {
            reports.push({
                reportName: "Claim Analytics",
                route: "reports/claim-analytics"
            });
        }
        if (store_1.usersStore.permissions.ReadOrderAnalytics) {
            reports.push({
                reportName: "Order Analytics",
                route: "/reports/order-analytics"
            });
        }
        if (store_1.usersStore.permissions.ReadSalesUsageSummary) {
            reports.push({
                reportName: "Sales Usage Summary",
                route: "/reports/sales-usage-summary"
            });
        }
        if (store_1.usersStore.permissions.ReadInsurancePayment) {
            reports.push({
                reportName: "Insurance Payment Report",
                route: "/reports/insurance-payment-report"
            });
        }
        if (store_1.usersStore.permissions.ReadDistributorAnalytics) {
            reports.push({
                reportName: "Distributor Ordering",
                route: "/reports/distributor-ordering"
            });
        }
        if (store_1.usersStore.permissions.ReadInventoryCount) {
            reports.push({
                reportName: "Inventory Count",
                route: "reports/inventory-count-report"
            });
        }
        // E-029
        if (store_1.usersStore.permissions.ReadCycleCount) {
            reports.push({
                reportName: "Cycle Count Report",
                route: "reports/cycle-count-report"
            });
        }
        if (store_1.usersStore.permissions.ReadDispenseAnalytics) {
            reports.push({
                reportName: "Dispensing Analytics",
                route: "/reports/dispense-report"
            });
        }
        if (store_1.usersStore.permissions.ReadClinicReimb) {
            reports.push({
                reportName: "Pharmacy Reimbursement",
                route: "/reports/clinic-reimbursement"
            });
        }
        if (store_1.usersStore.permissions.ReadAuditTrail) {
            reports.push({
                reportName: "Audit Trail",
                route: "/reports/audit-trail"
            });
        }
        if (store_1.usersStore.permissions.ReadPatientPaymentReport) { // D-002.911
            reports.push({
                reportName: "Patient Payment Report",
                route: "/reports/patient-payment-report"
            });
        }
        if (store_1.usersStore.permissions.ReadNegativeBalances) {
            reports.push({
                reportName: "Negative Balances",
                route: "/reports/negative-balances"
            });
        }
        if (store_1.usersStore.permissions.ReadARAgingReport) {
            reports.push({
                reportName: "A/R Aging Report",
                route: "/reports/ar-aging-report"
            });
        }
        //E-029
        if (store_1.usersStore.permissions.ReadNetworkContacts) {
            reports.push({
                reportName: "Network & Contacts",
                route: "/reports/network"
            });
        }
        if (store_1.usersStore.permissions.ReadTransactionCounts) {
            reports.push({
                reportName: "Transaction Counts",
                route: "/reports/transaction-counts"
            });
        }
        //E-029 //E-029.2 ReadCertificationsReport
        if (store_1.usersStore.permissions.ReadCertificationsReport) {
            reports.push({
                reportName: "Assets Report",
                route: "/reports/certifications-report"
            });
        }
        //E-029
        if (store_1.usersStore.permissions.ReadReversalsReport) {
            reports.push({
                reportName: "Reversals Report",
                route: "/reports/reversals-report"
            });
        }
        //E-029
        if (store_1.usersStore.permissions.ReadERXLogReport) {
            reports.push({
                reportName: "ERX Log",
                route: "/reports/erx-report"
            });
        }
        if (store_1.usersStore.permissions.ReadClaimErrorReport) { // E-064.51
            reports.push({
                reportName: "Claim Error Log",
                route: "/reports/claim-error-report"
            });
        }
        //E-029
        if (store_1.usersStore.permissions.ReadMailReport) {
            reports.push({
                reportName: "Mail Report",
                route: "/reports/mail-report"
            });
        }
        //E-029
        if (store_1.usersStore.permissions.ReadProductAudit) {
            reports.push({
                reportName: "Product Audit",
                route: "/reports/product-audit"
            });
        }
        //E-029
        if (store_1.usersStore.permissions.ReadBulkPDFExport) {
            reports.push({
                button: "Generate Files",
                reportName: "Bulk PDF Export",
                route: "/reports/pdf-export"
            });
        }
        // E-037.1 
        if (store_1.usersStore.permissions.ReadPharmacyReport) {
            reports.push({
                button: "Run Report",
                reportName: "Pharmacy Details",
                route: "/reports/pharmacy"
            });
        }
        // E-037.2  E-037.202
        if (store_1.usersStore.permissions.ReadPatientsReport) {
            reports.push({
                button: "Run Report",
                reportName: "Patient Reports",
                route: "/reports/patients-report"
            });
        }
        const filteredReports = reports.filter(report => {
            const lowerCaseName = report.reportName.toLowerCase();
            if (lowerCaseName.includes(this.filterText)) {
                return true;
            }
            return false;
        });
        return (React.createElement("div", { className: "reports__data__list__info" },
            React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: filteredReports, renderRow: this.renderListRow, withMargin: true, wideHeader: true })));
    }
    render() {
        return store_1.usersStore.permissions.ReadReports ? (React.createElement("div", null,
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "inventory-list__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Reporting" }))),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "floating-page" },
                    React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Reports", callBack: this.onCallback, filterText: this.filterText }),
                    this.renderList())))) : (store_1.usersStore.showLock());
    }
};
__decorate([
    mobx_1.observable
], ReportingList.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], ReportingList.prototype, "autoFocusForm", void 0);
__decorate([
    mobx_1.observable
], ReportingList.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], ReportingList.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], ReportingList.prototype, "sortedBy", void 0);
ReportingList = __decorate([
    mobx_react_1.observer
], ReportingList);
exports.ReportingList = ReportingList;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/reporting-list.tsx
// module id = 3861
// module chunks = 0